import { CTSError } from '../model/Errors';
let _WS: typeof WebSocket | undefined;

if (typeof WebSocket !== 'undefined') {
  _WS = WebSocket;
}

export function injectWebSocketImpl(ws: typeof WebSocket) {
  _WS = ws;
}

/**
 * @internal
 */
export function getWebSocketImpl() {
  if (_WS === undefined) {
    throw new CTSError('WebSocket implementation not initialized');
  }
  return _WS;
}
